<ra-ordered-list-drag-drop
  [list]="data.list"
  [allValues]="data.allValues"
  [bottomDirectionText]="data.bottomDirectionText"
  [topDirectionText]="data.topDirectionText"
  [bottomDirectionColor]="data.bottomDirectionColor"
  [topDirectionColor]="data.topDirectionColor"
  [styles]="data.styles"
  [id]="data.id"
  [label]="data.label"
  (orderChanged)="onOrderChanged($event)"
></ra-ordered-list-drag-drop>
